// Every read re-scores from the lake or the whole fleet, and the stored score moves only every few hours.
export const COVERAGE_STALE_MS = 5 * 60_000
